import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { minWidth } from '../../helpers/media-queries';
// import { isIE11OrEdge } from '../../helpers/browser-detection';

import $ from 'jquery';

const styles = () => ({
    root: {
        display: 'none',
        transition: 'opacity 0.5s',
        opacity: 1.0,
        zIndex: 999,          
        width: '100%',
        bottom: '60px',
        height: '1px',
        padding: 0,
        position: 'fixed',
        background: 'transparent',
        '& button': {
            '-webkit-animation': 'scrollToBottom 2s infinite', /* Safari 4+ */
            '-moz-animation':    'scrollToBottom 2s infinite', /* Fx 5+ */
            '-o-animation':      'scrollToBottom 2s infinite', /* Opera 12+ */
            'animation':         'scrollToBottom 2s infinite', /* IE 10+, Fx 29+ */
        },
        [minWidth.md]: {  
            display: 'block',
            marginLeft: '20px',
        },
        [minWidth.xl]: {  
            marginLeft: '-70px',
        },
        '&.scrolled': {
            opacity: 0.0,
        },
        '&.ie-fix': {
        }
    },
    btn: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontFamily: "'zx_spectrum7_boldregular', sans",
        width: '50px',
        height: '50px',
        '&:active': {
            transform: 'translateY(5%)',
        },
        '&:active, &:focus, &:visited': {
            border: 'none',
        },
        [minWidth.xl]: {
            marginBottom: '10px',
        }
    },
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    gameIsVisible: stores.ui.gameIsVisible,
})

class Arrow extends Component {
    state = {
        scrolled: true,
    }

    componentDidMount() {
      this._handleScroll();
      window.addEventListener("scroll", this._handleScroll);
      window.addEventListener("resize", this._handleScroll);  
    }
  
    componentWillUnmount() {
      window.removeEventListener("scroll", this._handleScroll);  
      window.removeEventListener("resize", this._handleScroll);  
    }

    render() {
        const { intl, classes } = this.props;
        const { scrolled } = this.state;
        return (
            <div className={classNames(classes.root, {
                scrolled: !!scrolled,
                // 'ie-fix': isIE11OrEdge(),
            })}>
                <button
                    type="button"
                    arial-label={intl['LOCALE.ACCESSIBILITY.SCROLL_TO_BOTTOM']}
                    className={classNames(classes.btn)}
                    onClick={this._handlePress}>
                    <img 
                        src="./static/images/scroll-button.png" 
                        alt={intl['LOCALE.ACCESSIBILITY.SCROLL_TO_BOTTOM']} 
                        title={intl['LOCALE.ACCESSIBILITY.SCROLL_TO_BOTTOM']}  />
                </button>
            </div>
        )
    }

    _handlePress = () => {
        const { offsetTop } = document.getElementById('sesion-personajes');
        $("html, body").animate({ scrollTop: offsetTop - 100 }, 600);
    }

    _handleScroll = () => {
      const { 
        innerHeight: height,
        pageYOffset: y,
      } = window;
      this.setState({ scrolled: y > (height / 2)})
    }
}

export default inject(mapper)(
    withStyles(styles)(Arrow)
);